import React from "react";
import { Search, Smartphone, Stethoscope } from "lucide-react";
import Reveal from "./template/view.reveal";

const STEPS = [
    { icon: Smartphone, title: "Créez votre compte", text: "Avec votre numéro de téléphone. Vous profitez de 3 mois de Premium offerts." },
    { icon: Search, title: "Choisissez un médecin", text: "Filtrez par spécialité et par ville, puis choisissez un créneau libre." },
    { icon: Stethoscope, title: "Consultez", text: "Au cabinet ou en vidéo. L'ordonnance arrive directement dans votre dossier." },
];

export default function ViewSteps() {
    return (
        <section id="how" className="py-24 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="text-center max-w-2xl mx-auto">
                    <p className="text-sm font-bold tracking-wider text-brand-600 uppercase">Comment ça marche</p>
                    <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-brand-950">Une consultation en trois étapes.</h2>
                </Reveal>
                <ol className="mt-14 grid md:grid-cols-3 gap-8 relative">
                    <div aria-hidden="true" className="hidden md:block absolute top-8 left-[16%] right-[16%] h-px bg-gradient-to-r from-brand-100 via-brand-300 to-brand-100" />
                    {STEPS.map(({ icon: Icon, title, text }, i) => (
                        <Reveal as="li" key={title} delay={i * 120} className="relative text-center">
                            <div className="relative mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-brand-400 to-brand-700 text-white flex items-center justify-center shadow-[0_18px_30px_-12px_rgba(74,49,194,0.6)]">
                                <Icon className="w-7 h-7" />
                                <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-white text-brand-700 text-xs font-extrabold flex items-center justify-center shadow">{i + 1}</span>
                            </div>
                            <h3 className="mt-6 text-lg font-bold text-brand-950">{title}</h3>
                            <p className="mt-2 text-slate-600 max-w-xs mx-auto">{text}</p>
                        </Reveal>
                    ))}
                </ol>
            </div>
        </section>
    );
}
